import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { filterToQuery, type DiffFilterState } from "../lib/diff-filter";

import { diffKeys } from "./query-keys";

export function useListDiff(filter: DiffFilterState) {
  return useQuery({
    queryKey: diffKeys.list(filter),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/reports/inventory-diff", {
        params: { query: filterToQuery(filter) },
      });
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });
}
